// initial state
import axios from "axios";

const state = () => ({
    all: [],
    clients: [],
    suppliers: [],
    createGroupSlideOutOpen: false,
    group: {
        id: null,
        name: null,
        organisations: null
    }
})

// getters
const getters = {}

// actions
const actions = {
    async getAllClients ({ commit }) {
        axios.get(route('frontend.organisations.clients.list')).then(result => {
            commit('setClients', result.data)
        });
    },
    async getAllSuppliers ({ commit }) {
        axios.get(route('frontend.organisations.suppliers.list')).then(result => {
            commit('setSuppliers', result.data)
        });
    },
    openCreateGroup ({ commit }, group = null ) {
        commit('openCreateGroup', group)
    },
    closeCreateGroup ({ commit }) {
        commit('closeCreateGroup', false)
    },
    addClientToGroup( { commit }, client) {
        commit('addClientToGroup', client)
    },
    deleteClientFromGroup({commit}, client) {
        commit('deleteClientFromGroup', client);
    }
}

// mutations
const mutations = {
    setOrganisations (state, organisations) {
        state.all = organisations
    },
    setClients (state, clients) {
        state.clients = clients
    },
    setSuppliers (state, suppliers) {
        state.suppliers = suppliers
    },
    openCreateGroup(state, group) {
        state.createGroupSlideOutOpen = true;
        state.group = group;
    },
    closeCreateGroup(state, value) {
        state.createGroupSlideOutOpen = value;
        state.group = null;
    },
    addClientToGroup(state, client) {
        state.group.organisations.push(client);
    },
    deleteClientFromGroup(state, client) {
        state.group.organisations = state.group.organisations.filter(x => {
            return x.id !== client.id;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
